// Action creators for the commission accounts slice.
// One shared factory, one line per action.

import * as types from '../../lib/actionTypes.es6';

function creator(type) {
  return function create(payload) {
    return { type: type, payload: payload };
  };
}

// Cross-agent ledger: GET /api/commission-accounts/agents/transactions
export var getCommissionAccountsRequest =
  creator(types.GET_COMMISSION_ACCOUNTS_REQUEST);
export var getCommissionAccountsSuccess =
  creator(types.GET_COMMISSION_ACCOUNTS_SUCCESS);
export var getCommissionAccountsFailed =
  creator(types.GET_COMMISSION_ACCOUNTS_FAILURE);

// One agent's latest account transaction, which the service treats as their
// current balance.
export var getAgentCommissionAccountRequest =
  creator(types.GET_AGENT_COMMISSION_ACCOUNT_REQUEST);
export var getAgentCommissionAccountSuccess =
  creator(types.GET_AGENT_COMMISSION_ACCOUNT_SUCCESS);
export var getAgentCommissionAccountFailed =
  creator(types.GET_AGENT_COMMISSION_ACCOUNT_FAILURE);

export var getCommissionAccountByGuidRequest =
  creator(types.GET_COMMISSION_ACCOUNT_BY_GUID_REQUEST);
export var getCommissionAccountByGuidSuccess =
  creator(types.GET_COMMISSION_ACCOUNT_BY_GUID_SUCCESS);
export var getCommissionAccountByGuidFailed =
  creator(types.GET_COMMISSION_ACCOUNT_BY_GUID_FAILURE);

// One agent's running ledger.
export var getAgentCommissionAccountTransactionsRequest =
  creator(types.GET_AGENT_COMMISSION_ACCOUNT_TRANSACTIONS_REQUEST);
export var getAgentCommissionAccountTransactionsSuccess =
  creator(types.GET_AGENT_COMMISSION_ACCOUNT_TRANSACTIONS_SUCCESS);
export var getAgentCommissionAccountTransactionsFailed =
  creator(types.GET_AGENT_COMMISSION_ACCOUNT_TRANSACTIONS_FAILURE);

// The handoff to the batch payout builder. Payload is an array of agent guids.
export var setPayoutAgentSelection =
  creator(types.SET_PAYOUT_AGENT_SELECTION);
export var clearPayoutAgentSelection =
  creator(types.CLEAR_PAYOUT_AGENT_SELECTION);
